<template>
  <div class="files-tab-overview">
    <v-card class="mb-6">
      <div class="pa-5">
        <v-row class="align-sm-center">
          <v-col cols="12">
            <v-card-title class="pa-0">Visa OI Files List</v-card-title>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <ChargebackFilesSkeletonLoader v-if="isLoading" />

    <div v-else class="files-list">
      <v-row v-if="files.length" class="files-list">
        <v-col v-for="(file, key) in files" :key="key" cols="6" sm="4" md="3" lg="2">
          <ChargebackFile :file="file" />
        </v-col>
      </v-row>

      <v-card v-else>
        <v-card-text class="text-center">
          <p class="body-2 pa-2 ma-0">No files found.</p>
        </v-card-text>
      </v-card>

      <v-pagination
        v-if="totalCount > options.itemsPerPage"
        v-model="options.page"
        :length="Math.ceil(totalCount / options.itemsPerPage)"
        :total-visible="7"
        class="mt-6"
      />
    </div>
  </div>
</template>

<script>
import useChargebackFilesList from '@/views/chargebacks/chargeback-files/useChargebackFilesList';
import ChargebackFilesSkeletonLoader
  from '@/views/chargebacks/chargeback-files/_partials/ChargebackFilesSkeletonLoader';
import { ChargebackFileTypeEnum } from '@/enums/chargeback-file-type.enum';
import ChargebackFile
  from '@/views/chargebacks/chargeback-files/_partials/ChargebackFile';

export default {
  components: { ChargebackFile, ChargebackFilesSkeletonLoader },
  setup() {
    const { isLoading, files, totalCount, options } = useChargebackFilesList(ChargebackFileTypeEnum.VerifiOi);

    return {
      isLoading,
      files,
      totalCount,
      options,
    };
  },
};
</script>

